import { AppContext } from "./AppContext";
import React, { useState } from "react";

const AppState = (props) => {
  const [currencySymbol, setCurrencySymbol] = useState(
    JSON.parse(localStorage.getItem("customer_currency")) || ''
  );

return (
  <AppContext.Provider value={{ currencySymbol, setCurrencySymbol }}>
    {props.children}
  </AppContext.Provider>
);
};

export default AppState;